import { createUrl } from "@touchtech/web-api-client";

import { getEnvValue } from "@is/utils/env";

const baseUrl = getEnvValue("VITE_INSTORE_CLOUD_SERVICE_URL");

export const createBasketUrl = () => createUrl(baseUrl, `api/instore/baskets`);

export const createBasketUpdateUrl = () =>
  createUrl(baseUrl, `api/instore/baskets`);

export const createBasketAbandonUrl = () =>
  createUrl(baseUrl, `api/instore/baskets/abandon`);

export const createAddParkedBasketUrl = () =>
  createUrl(baseUrl, `api/instore/baskets/parked/add`);

export const createGetParkedBasketsUrl = () =>
  createUrl(baseUrl, `api/instore/baskets/parked/list`);

export const createRestoreParkedBasketUrl = (basketId: string) =>
  createUrl(baseUrl, `api/instore/baskets/parked/${basketId}/restore`);
